var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('duration-quick-settings',{attrs:{"value":_vm.task_duration_remaining,"quickDurationSettings":{
    '0 min': 0 * 60,
    '1 min': 1 * 60,
    '3 min': 3 * 60,
    '5 min': 5 * 60,
    '10 min': 10 * 60,
    '15 min': 15 * 60,
    '20 min': 20 * 60,
    '25 min': 25 * 60,
    '30 min': 30 * 60,
    '45 min': 45 * 60,
    '1 h': 1 * 60 * 60,
    '2 h': 2 * 60 * 60,
    '3 h': 3 * 60 * 60,
    '4 h': 4 * 60 * 60,
    '8 h': 8 * 60 * 60,
  }},on:{"save":function($event){return _vm.onQuickSetDurationRemaining($event)}}},[_vm._v("\n  "+_vm._s(_vm._f("hoursMinutes")(_vm.task_duration_remaining))+"\n")]),_c('br')],1)}
var staticRenderFns = []

export { render, staticRenderFns }